module.exports = __webpack_public_path__ + "img/CAT_PROTECTION.9efe90b8.svg";